import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import './Profile.css';
import { BASE_URL, IMGAGE_URL } from '../../Config';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Notiflix from 'notiflix';
import { FaCheckCircle } from 'react-icons/fa';
import { MdVerified } from 'react-icons/md';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function StudentProfile() {
  const fileInputRef = useRef(null);
  const userdatatoken = localStorage.getItem('userDatatoken');
  const token = localStorage.getItem('token_type');
const [userpic,setUserpic] = useState('')
  const [firstname, setFirstname] = useState("");
  const [profile, setProfile] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [dob, setDob] = useState(null);
  const [gender, setGender] = useState(null);
  const [pincode, setPincode] = useState(null);
  const [referralCode, setReferralCode] = useState("");
  const [walletAmount, setWalletAmount] = useState(0);
  const [formerror, setFormerror] = useState([])
  const [formerror1, setFormerror1] = useState([])
  const [formerror2, setFormerror2] = useState([])
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState('101');
  const [selectedStateId, setSelectedStateId] = useState(null);
  const [selectedCityId, setSelectedCityId] = useState(null);
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
      setOpen(true);
  };

  const handleClose = () => {
      setOpen(false);
  };
  const [openemail, setOpenemail] = React.useState(false);
  const handleClickOpenemail = () => {
      setOpenemail(true);
  };

  const handleCloseemail = () => {
      setOpenemail(false);
  };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
const[userdata,setUserdata]= useState('')
  const tokendata = `Bearer ${userdatatoken.replace(/"/g, '')}`;

  // Fetch profile data
  const fetchProfileData = async () => {
    try {
      const response = await axios.get(BASE_URL + 'profiles', {
        headers: {
          Accept: "application/json",
          Authorization: tokendata
        }
      });
      setUserdata(response.data.data)
      const data = response.data.data;
      setUserpic(data.image)
      setFirstname(data.name || "");
      setMobile(data.contact || "");
      setEmail(data.email || "");
      setAddress(data.address || "");
      setCountry(data.country || null);
      setState(data.state || null);
      setCity(data.city || null);
      setDob(data.dob || null);
      setGender(data.gender || null);
      setPincode(data.pincode || "");
      setReferralCode(data.referral_code || "");
      setWalletAmount(data.wallet_amount || 0);

      localStorage.setItem('userData', JSON.stringify(data));
    } catch (error) {
      console.log("Error fetching profile data:", error);
    }
  };

  // Fetch country, state, and city data
  const fetchCountryData = async () => {
    try {
      const response = await axios.get(BASE_URL + 'country');
      setCountryData(response.data.data || []);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStateData = async (countryId) => {
    try {
      const response = await axios.get(BASE_URL + 'state/' + countryId);
      setStateData(response.data.data || []);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCityData = async (stateId) => {
    try {
      const response = await axios.get(BASE_URL + 'city/' + stateId);
      setCityData(response.data.data || []);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfileData();
    fetchCountryData();
  }, []);

  useEffect(() => {
    if (selectedCountryId) {
      fetchStateData(selectedCountryId);
    }
  }, [selectedCountryId]);

  useEffect(() => {
    if (selectedStateId) {
      fetchCityData(selectedStateId);
    }
  }, [selectedStateId]);

  const handleCountryChange = (e) => {
    setSelectedCountryId(e.target.value);
    setSelectedStateId(null); // Reset selected state when country changes
  };

  const handleStateChange = (e) => {
    setSelectedStateId(e.target.value);
  };

  const handleImageClick = () => {
    // Trigger the file input click
    fileInputRef.current.click();
};
  const handleCityChange = (e) => {
    setSelectedCityId(e.target.value);
  };
  const handleDocumentChange1 = (e) => setProfile(e.target.files[0]);
  // Update profile function
  const updateProfile = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", firstname);
    // formData.append("last_name", lastname);
    formData.append("email", email);
    formData.append("mobile_number", mobile);
    formData.append("image", profile);
    // formData.append("password_confirmation", passwordConfirm);
    formData.append("address", address);
    formData.append("country", selectedCountryId);
    formData.append("state", selectedStateId);
    formData.append("city", selectedCityId);
    formData.append("dob", dob);
    formData.append("gender", gender);
    formData.append("pincode", pincode);
    // formData.append("referral_code", referralCode);

    try {
      const response = await axios.post(BASE_URL + "updateprofile", formData, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
          Authorization: tokendata,
        },
      });

      if (response.data) {
        // Handle successful response (e.g., show a success message)
        Notiflix.Notify.success('Profile Update');
        fetchProfileData(); // Refresh the profile data after update
      }

    } catch (error) {
      setFormerror(error.response.data.errors)
      console.log("Error updating profile:", error);
    }
  };
  const changepassword = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("new_password", password);
    formData.append("confirm_password", passwordConfirm);
  

    try {
      const response = await axios.post(BASE_URL + "updatepassword", formData, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
          Authorization: tokendata,
        },
      });

      if (response.data) {
        // Handle successful response (e.g., show a success message)
        fetchProfileData(); // Refresh the profile data after update
      }

    } catch (error) {
      console.log("Error updating profile:", error);
    }
  };

  const [otpmobile,setOtpmobile] = useState('')
  const [otpstatus, setOtpstatus] = useState(false)
  const [otpchange,setOtpchange] = useState('')
  const [otpemail,setOtpemail] = useState('')

  const [otpsendemail,setOtpsendemail] = useState('')
  const sendotpmobile = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("mobile_number", otpmobile);
  
  

    try {
      const response = await axios.post(BASE_URL + "send-otp-change-mobile-number", formData, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
          Authorization: tokendata,
        },
      });

      if (response.data) {
        setOtpstatus(true)
        fetchProfileData(); // Refresh the profile data after update

      }

    } catch (error) {
      setFormerror2(error.response.data.errors)
      console.log("Error updating profile:", error);
    }
  };
  const verifymobile = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("mobile_number", otpmobile);
    formData.append("otp", otpchange);
  

    try {
      const response = await axios.post(BASE_URL + "update-mobile-number", formData, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
          Authorization: tokendata,
        },
      });

      if (response.data) {
       
        fetchProfileData(); // Refresh the profile data after update
        setOpen(false)
      }

    } catch (error) {
      console.log("Error updating profile:", error);
    }
  };
  const sendotpemail = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("email", otpemail);
  
  

    try {
      const response = await axios.post(BASE_URL + "send-otp-change-email", formData, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
          Authorization: tokendata,
        },
      });

      if (response.data) {
        setOtpstatus(true)
        fetchProfileData(); // Refresh the profile data after update
      }

    } catch (error) {
      setFormerror1(error.response.data.errors)
      console.log("Error updating profile:", error);
    }
  };
  const verifyemail = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("email", otpemail);
    formData.append("otp", otpsendemail);
  

    try {
      const response = await axios.post(BASE_URL + "update-email", formData, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
          Authorization: tokendata,
        },
      });

      if (response.data) {
       
        fetchProfileData(); // Refresh the profile data after update
        setOpenemail(false)
      }

    } catch (error) {
      console.log("Error updating profile:", error);
    }
  };
  return (
    <div className="dashboard-main-card">
      <div className='user-update-form mb-3'>
        <h3 className='mb-3'>My Profile</h3>
        <form onSubmit={updateProfile}>
       

<div className="form-group row border-bottom pb-3">
  
  {/* MOBILE */}
  <label htmlFor="mobile" className="col-sm-2 col-form-label">
    Mobile Number
  </label>

  <div className="col-sm-4" style={{ position: "relative" }}>
    <input
      type="text"
      className="form-control"
      id="mobile"
      value={mobile}
      onChange={(e) => setMobile(e.target.value)}
      readOnly
    />

    {/* ✅ Verified Icon */}
    {mobile && (
      <MdVerified
        style={{
          color: "blue",
          position: "absolute",
          right: "20px",
          top: "10px"
        }}
      />
    )}

    {formerror.mobile_number && <p className="error">{formerror.mobile_number}</p>}
    {formerror2.mobile_number && <p className="error">{formerror2.mobile_number}</p>}

    <button
      style={{
        border: "none",
        backgroundColor: "#E93014",
        color: "#fff",
        borderRadius: "3px",
        padding: "5px 10px",
        marginTop: "5px"
      }}
      onClick={handleClickOpen}
    >
      Update Mobile No.
    </button>
  </div>

  {/* EMAIL */}
  <label htmlFor="email" className="col-sm-2 col-form-label">
    Email Id
  </label>

  <div className="col-sm-4" style={{ position: "relative" }}>
    <input
      type="text"
      className="form-control"
      id="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      readOnly
    />

    {/* ✅ Verified Icon */}
    {email && (
      <MdVerified 
        style={{
          color: "blue",
          position: "absolute",
          right: "20px",
          top: "10px"
        }}
      />
    )}

    {formerror.email && <p className="error">{formerror.email}</p>}

    <button
      style={{
        border: "none",
        backgroundColor: "#E93014",
        color: "#fff",
        borderRadius: "3px",
        padding: "5px 10px",
        marginTop: "5px"
      }}
      onClick={handleClickOpenemail}
    >
      Update E-mail
    </button>
  </div>
</div>

          <div className="form-group row">
          
            {/* <label htmlFor="firstname" className="col-sm-2 col-form-label">Profile</label>
            <div class="col-sm-4 p-image">
              <img src={IMGAGE_URL+userpic}></img>
            </div>
            <div className="col-sm-6">
            <label htmlFor="firstname" className="col-sm-4 col-form-label">Profile Update</label>
              <input
                type="file"
                className="form-control"
                id="inputCity"
                onChange={handleDocumentChange1}
              />
            </div> */}
             {/* <label htmlFor="firstname" className="col-sm-2 col-form-label">Change Profile</label> */}
            <div className="col-sm-2 p-image">
                {/* Profile Image, clicking this will trigger the file input */}
                <img 
                    src={IMGAGE_URL + userpic} 
                    alt="Profile" 
                    style={{ cursor: 'pointer' }}
                    onClick={handleImageClick} 
                />
                 
                {/* <label htmlFor="firstname" className="col-sm-8 col-form-label" style={{marginTop:"-100px"}}>Change Profile</label> */}
            </div>
            <div className="col-12 col-md-12 col-lg-6">
                {/* Hidden file input */}
                <label htmlFor="firstname" className="col-sm-4 col-form-label">Change Profile</label>
                <input
                    type="file"
                    className="form-control"
                    id="inputCity"
                    ref={fileInputRef}
                    onChange={handleDocumentChange1}
                    // style={{ display: 'none' }} // Hide the file input
                />
            </div>

            
            <div className="col-12 col-md-12 col-lg-6 mb-3">
              <label htmlFor="firstname" className="col-sm-2 col-form-label ">Full Name</label>
              <input
                type="text"
                className="form-control"
                id="firstname"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
              />
                {/* {formerror.email && <p className="error">{formerror.email}</p>} */}
            </div>
            <label htmlFor="firstname" className="col-sm-2 col-form-label">Gender</label>
            <div className="col-sm-4 mb-3">
            <select
                className="custom-select mr-sm-2"
                id="country"
                value={gender}
                onChange={(e) => { setGender(e.target.value);  }}
              >
           <option  >
                    Select Gender
                  </option>
                  <option  value={"male"}>
                    Male
                  </option>
                  <option  value={"female"}>
                    Female
                  </option>
                  <option  value={"other"}>
                    Other
                  </option>
              </select>
              {/* {formerror.email && <p className="error">{formerror.email}</p>} */}
            </div>
          </div>
        
          <div className="form-group mb-3 row">
            <label htmlFor="address" className="col-sm-2 col-form-label">Address</label>
            <div className="col-sm-10">
              <input
                type="text"
                className="form-control"
                id="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
                {formerror.address && <p className="error">{formerror.address}</p>}
            </div>
          </div>
          <div className="form-group mb-3 row">
            <label htmlFor="country" className="col-sm-2 col-form-label">Country</label>
            <div className="col-sm-4">
              <select
                className="custom-select mr-sm-2"
                id="country"
                value={country || ""}
                onChange={(e) => { setCountry(e.target.value); handleCountryChange(e); }}
              >
                  <option  >
                  {userdata.country_name}
                 </option>
                {countryData.map((country) => (
                  <>
                 
                  <option key={country.id} value={country.id}>
                    {country.name}
                  </option>
                  </>
                ))}
              </select>
              {formerror.country && <p className="error">{formerror.country}</p>}
            </div>
            <label htmlFor="state" className="col-sm-2 col-form-label">State</label>
            <div className="col-sm-4 mb-3">
              <select
                className="custom-select mr-sm-2"
                id="state"
                value={state || ""}
                onChange={(e) => { setState(e.target.value); handleStateChange(e); }}
              >
                 <option  >
                  {userdata.state_name}
                 </option>
                {stateData.map((state) => (
                  <>
                   
                 <option key={state.id} value={state.id}>
                    {state.name}
                  </option>
                  </>
                 
                ))}
              </select>
              {formerror.state && <p className="error">{formerror.state}</p>}
            </div>
          </div>

          <div class="form-group mb-3 row">
            <label for="inputPassword" class="col-sm-2 col-form-label">City</label>
            <div class="col-sm-4">
              <select class="custom-select  mr-sm-2" id="inlineFormCustomSelectPref" onChange={(e) => { setSelectedCityId(e.target.value) }}>
              <option  >
                  {userdata.city_name}
                 </option>
                {cityData.map((city) => (
                  <>
                   
                 <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                  </>
                
                ))}
              </select>
              {formerror.city && <p className="error">{formerror.city}</p>}
            </div>
            <label for="inputPassword" class="col-sm-2 col-form-label">Pin Code</label>
            <div class="col-sm-4">
              <input type="text" class="form-control" id="inputPassword" value={pincode} onChange={(e) => setPincode(e.target.value)} />
              {formerror.pincode && <p className="error">{formerror.pincode}</p>}
            </div>
          </div>
          <div class="form-group mb-3 row">
            <label for="inputPassword" class="col-sm-2 col-form-label">Date of Birth</label>
            <div class="col-sm-4">
              <input type="date" class="form-control" id="inputPassword" placeholder="+91-0909090909" value={dob} onChange={(e) => setDob(e.target.value)} />
              {formerror.dob && <p className="error">{formerror.dob}</p>}
            </div>
            <label for="inputPassword" class="col-sm-2 col-form-label">Referral Code </label>
            <div class="col-sm-4">
              <input type="text" class="form-control" id="inputPassword" value={referralCode} readOnly />
            </div>
          </div>
          <button className='update-button' onClick={updateProfile}>Update Profile</button>
        </form>
      </div>
      <div className='user-update-form'>
        <h3 className='mb-3'>Login and Security</h3>
        <form>
          <div class="form-group row mb-3">
            <label for="inputPassword" class="col-sm-2 col-form-label">New Password</label>
            <div class="col-sm-10">
              <input type="text" class="form-control" id="inputPassword" placeholder="Enter New Password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>

          </div>

          <div class="form-group row mb-3">
            <label for="inputPassword" class="col-sm-2 col-form-label">Confirm New Password</label>
            <div class="col-sm-10">
              <input type="text" class="form-control" id="inputPassword" placeholder="Confirm New Password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} />
            </div>
          </div>

          <button className='update-button' onClick={changepassword}>Change Password</button>
        </form>
      </div>
      <Dialog
           
           open={open}
           TransitionComponent={Transition}
           keepMounted
           onClose={handleClose}
           aria-describedby="alert-dialog-slide-description"
       >
           <DialogTitle style={{ borderBottom: "1px solid gray", marginBottom: "10px", fontSize: "20px", fontWeight: "700" , width:"500px"}}>{"Update Mobile"}</DialogTitle>
           <DialogContent>
               {/* <p className='mb-5' style={{ marginBottom: "10px", fontSize: "13px", fontWeight: "700" }}>{"We have sent OTP to your registered Mobile Number, Please enter to Verify"}</p> */}
               <DialogContentText id="alert-dialog-slide-description" >
                   <form>

                       <div class="form-group row mt-3">
                           <label for="inputPassword" class="col-sm-4 col-form-label">Mobile</label>
                           <div class="col-sm-8">
                               <input type="text" class="form-control" id="inputPassword" placeholder="Mobile" onChange={(e)=>setOtpmobile(e.target.value)}/>
                               {formerror2.mobile_number && <p className="error">{formerror2.mobile_number}</p>}
                           </div>
                       </div>
                       {otpstatus == true ? <div class="form-group row mt-3">
                           <label for="inputPassword" class="col-sm-4 col-form-label">OTP</label>
                           <div class="col-sm-8">
                               <input type="text" class="form-control" id="inputPassword" placeholder="OTP" onChange={(e)=>setOtpchange(e.target.value)} />
                           </div>
                       </div>: null}
                      
                   </form>
               </DialogContentText>
           </DialogContent>
           <DialogActions>
             {otpstatus== true ? <Button onClick={verifymobile}>Update Now</Button>: <Button onClick={sendotpmobile}>Send OTP</Button>}
              
           </DialogActions>
       </Dialog>
       <Dialog
           
           open={openemail}
           TransitionComponent={Transition}
           keepMounted
           onClose={handleCloseemail}
           aria-describedby="alert-dialog-slide-description"
       >
           <DialogTitle style={{ borderBottom: "1px solid gray", marginBottom: "10px", fontSize: "20px", fontWeight: "700" , width:"500px"}}>{"E-mail Update"}</DialogTitle>
           <DialogContent>
               {/* <p className='mb-5' style={{ marginBottom: "10px", fontSize: "13px", fontWeight: "700" }}>{"We have sent OTP to your registered Mobile Number, Please enter to Verify"}</p> */}
               <DialogContentText id="alert-dialog-slide-description" >
                   <form>

                       <div class="form-group row mt-3">
                           <label for="inputPassword" class="col-sm-4 col-form-label">E-mail</label>
                           <div class="col-sm-8">
                               <input type="text" class="form-control" id="inputPassword" placeholder="E-mail" onChange={(e)=>setOtpemail(e.target.value)}/>
                               {formerror1.email && <p className="error">{formerror1.email}</p>}
                           </div>
                       </div>
                       {otpstatus == true ? <div class="form-group row mt-3">
                           <label for="inputPassword" class="col-sm-4 col-form-label">OTP</label>
                           <div class="col-sm-8">
                               <input type="text" class="form-control" id="inputPassword" placeholder="OTP" onChange={(e)=>setOtpsendemail(e.target.value)} />
                           </div>
                       </div>: null}
                      
                   </form>
               </DialogContentText>
           </DialogContent>
           <DialogActions>
             {otpstatus== true ? <Button onClick={verifyemail}>Update Now</Button>: <Button onClick={sendotpemail}>Send OTP</Button>}
              
           </DialogActions>
       </Dialog>
    </div>
  );
}

export default StudentProfile;
